import axios from 'axios';
import Config from '../app-config';
import { getAuthToken } from './generatedClientConfig';

/**
 * The call service is a separate backend from the domain admin service and is not
 * part of the generated client, so it gets this small hand-written client.
 * Errors surface through the global axios response interceptor installed in
 * generatedClientConfig.
 */
export default async function callPhone(phoneNumber: string, message: string): Promise<void> {
    let baseUrl = Config.callService.endpoint;
    if (baseUrl && baseUrl[baseUrl.length - 1] !== '/')
        baseUrl += '/';

    const token = getAuthToken();
    await axios.post(
        `${baseUrl}calls`,
        { phoneNumber, message },
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
}
